export const environment = {
    production: false,
    api: 'https://api-cms-admin.wepay4u.com/api/v1/',
    urlAcces: 'https://api-core-access.wepay4u.com/v1/',
    urlMultiservi: 'https://api.multiservi.com.co/api/'
};

